module.exports = __webpack_public_path__ + "app-static/img/07.0ab40589.jpg";